import { get, patch } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./signup-form-response.serializer";

export const getSignupFormResponses = async (
  token: string,
  baseUrl: string
) => {
  try {
    const queryPath = `${baseUrl}/signup_form_response/current`;

    const res = await get(token, queryPath);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const changeSignupFormResponses = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/signup_form_response`;
    const serializedBody = serialize(body);

    const res = await patch(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
